import { configureStore } from '@reduxjs/toolkit';
import allReducers from './GlobalReducers';

export const store = configureStore({
    reducer: allReducers,
    devTools: process.env.NODE_ENV !== 'production', // Automatically uses Redux DevTools when not in production
});

export default store;